import { memo } from "react";
import { MarkdownTypewriter } from "react-markdown-typewriter";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import ReactMarkdown from "react-markdown";

const MarkdownComponent = memo(function MarkdownComponent({
  text,
  isTypeWriting = false,
  isUser = false,
}: {
  text: string;
  isTypeWriting?: boolean;
  isUser?: boolean;
}) {
  return (
    <div
      className={` max-w-none dark:prose-invert  ${
        isUser ? "prose-invert" : "prose"
      }`}
      // style={{
      //   overflow: "auto",
      // }}
    >
      {isTypeWriting ? (
        <MarkdownTypewriter
          delay={1}
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeRaw]}
        >
          {text}
        </MarkdownTypewriter>
      ) : (
        <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
          {text}
        </ReactMarkdown>
      )}
    </div>
  );
});

export default MarkdownComponent;
